/**
 * Ryan O'Dowd
 * 2024-01-06
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: {
      display: 'flex',
      // @TODO: width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '15%',
      paddingTop: '15%',
      marginBottom: '33%',
      paddingBottom: '33%',
    },
  };
};

export default getStyles;
